import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import { useOverlay } from '@flipster/overlay';
import { TextButton } from '@flipster/react/design-system/text-button';
import { css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';

import { PusdtAutoConversionModal } from './modal';
import { pusdtAutoConversionBunja } from './state';

export const PusdtAutoConversionSection = () => {
  const overlay = useOverlay();
  const { isAutoConversionPusdtEnabledAtom } = useBunja(pusdtAutoConversionBunja);
  const isAutoConversionPusdtEnabled = useAtomValue(isAutoConversionPusdtEnabledAtom);

  return (
    <div
      className={hstack({
        h: 48,
        justify: 'space-between',
        borderTopWidth: '1px',
        borderTopStyle: 'solid',
        borderColor: 'border.default.level-1',
      })}
    >
      <span className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-5' })}>
        <FormattedMessage id='Earn.r260220.Pusdt_auto_subscribe_to_premium_earn_usdt' />
      </span>
      <TextButton
        label={
          isAutoConversionPusdtEnabled ? (
            <FormattedMessage id='Autogen_common.r251126.s_Turn_off' />
          ) : (
            <FormattedMessage id='Autogen_common.r251126.s_Turn_on' />
          )
        }
        color={isAutoConversionPusdtEnabled ? 'passive' : 'accent'}
        size='small'
        onClick={() =>
          overlay.open(({ isOpen, onClose, unmount }) => (
            <PusdtAutoConversionModal isOpen={isOpen} onClose={onClose} onExit={unmount} />
          ))
        }
      />
    </div>
  );
};
